import { render, staticRenderFns } from "./InstrumentWizard.vue?vue&type=template&id=b3e10d3e&"
import script from "./InstrumentWizard.vue?vue&type=script&lang=ts&"
export * from "./InstrumentWizard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports